import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import type { BugsnagPluginReactResult } from "@bugsnag/plugin-react";
import React from "react";
import * as rpc from "../common/jsonRpcRoutes";

let isBugsnagInitialised = false;
let ErrorBoundaryComponent: ReturnType<BugsnagPluginReactResult["createErrorBoundary"]> | null = null;

export async function initialiseBugsnag(): Promise<void> {
  if (isBugsnagInitialised) {
    return;
  }

  try {
    const bugsnagConfig = await rpc.call("/bugsnag-key", {});

    if (!bugsnagConfig.apiKey) {
      return;
    }

    Bugsnag.start({
      apiKey: bugsnagConfig.apiKey,
      plugins: [new BugsnagPluginReact()],
      releaseStage: bugsnagConfig.releaseStage,
      enabledReleaseStages: ["production", "qa", "demo"],
      appVersion: import.meta.env.VITE_APP_VERSION ?? "unknown",
      metadata: {
        app: {
          name: "guest-checkout",
        },
      },
    });

    isBugsnagInitialised = true;
    ErrorBoundaryComponent = Bugsnag.getPlugin("react")?.createErrorBoundary(React) ?? null;
  } catch (error) {
    console.error("Failed to initialise Bugsnag:", error);
  }
}

export function getErrorBoundary() {
  return ErrorBoundaryComponent;
}

export const notifyBugsnag = (error: Error, metadata?: Record<string, unknown>) => {
  if (isBugsnagInitialised) {
    Bugsnag.notify(error, (event) => {
      if (metadata) {
        event.addMetadata("context", metadata);
      }
    });
  }
};

export default Bugsnag;
